import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Loading ..."))
      : (_openBlock(), _createBlock(_component_v_window, {
          key: 1,
          modelValue: _ctx.activeTab,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activeTab) = $event)),
          class: "oss-dark"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_window_item, {
              value: "CONNECTOR",
              class: "oss-dark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  class: "py-2",
                  style: {"flex-wrap":"nowrap"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "8" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field_filled, {
                          modelValue: _ctx.search,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                          "append-inner-icon": "$search",
                          clearable: "",
                          "onClick:clear": _cache[1] || (_cache[1] = ($event: any) => (_ctx.search = '')),
                          label: "Rechercher",
                          "hide-details": "",
                          class: "grow-1"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select_filled, {
                          modelValue: _ctx.filtredType,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filtredType) = $event)),
                          items: _ctx.types,
                          label: "Type",
                          "hide-details": "",
                          class: "shrink-1",
                          density: "compact",
                          "item-title": "text"
                        }, {
                          item: _withCtx(({ props, item }) => [
                            (
                                        item.raw.divider ||
                                        (item.raw.props && item.raw.props.divider)
                                    )
                              ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
                              : (
                                        item.raw.header || (item.raw.props && item.raw.props.header)
                                    )
                                ? (_openBlock(), _createBlock(_component_v_list_subheader, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.raw.header), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createBlock(_component_v_list_item, _mergeProps({ key: 2 }, props, {
                                    value: item.value,
                                    class: "text-capitalize"
                                  }), null, 16, ["value"]))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_list, { lines: "three" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredConnectors, (c, index) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: c.id,
                        onClick: () => {}
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_avatar, { size: "40" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_img, {
                                src: _ctx.getLogo(c.application),
                                width: "40",
                                cover: ""
                              }, null, 8, ["src"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        append: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            elevation: "0",
                            disabled: c.active,
                            onClick: ($event: any) => (_ctx.redirectToConnection(c))
                          }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createTextVNode(" Ajouter ")
                            ])),
                            _: 2
                          }, 1032, ["disabled", "onClick"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(c.name), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_list_item_subtitle, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getType(c.type)), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, {
              value: "SPECIFICATION",
              class: "oss-dark"
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
  ]))
}